var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"program-button_content"},[_c('CtaButton',{attrs:{"text":_vm.buttonText,"text-path":"#application-form","wrapper-class":"program-flex"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }